import { useContext, useEffect } from 'react';
import FormContext from '../Form/FormContext.js';
import { setProp } from '../Utils/formHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
function notifica(event, name, value, onChange, onFormChange, stato) {
    if (onFormChange && name) {
        const obj = {};
        setProp(name, value, obj, stato);
        onFormChange(obj, name, value);
    }
    if (onChange) {
        onChange(event);
    }
}
/**
 * Hook utilizzata per agganciare un componente al contesto FormContext
 */
function useForm(name, resetHandler, valido) {
    const { addToForm, isValid, onFormChange, removeFromForm, resetta, stato, validare, } = useContext(FormContext);
    useEffect(() => {
        if (name && addToForm) {
            addToForm(name, valido, resetHandler);
        }
        return () => {
            if (removeFromForm && name) {
                removeFromForm(name);
            }
        };
    }, [addToForm, name, removeFromForm, resetHandler, valido]);
    return {
        isValid,
        onFormChange,
        resetta,
        stato,
        validare,
        notifica: (notifica),
    };
}

export { useForm as default };
